import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import {
  IdDto,
  LangDto,
  MainProductCategoryDto,
  idSchema,
  mainProductCategorySchema,
} from "@client/common";

export const fetchDietProductsRemoved = async (
  dietId: string,
): Promise<ApiResponse<RemovedProductDto[]>> => {
  const response = await fetchData(
    `/dietitian/diets/${dietId}/products-removed`,
    APIMethods.GET,
  );

  return responseSchema.validate(response);
};

interface TranslationLangDto {
  lang: LangDto;
  name: string;
}

interface ProductDto {
  id: number;
  name: string;
  category: IdDto;
  translations: TranslationLangDto[];
}

export interface RemovedProductDto {
  from: ProductDto;
  mainProductCategory: MainProductCategoryDto;
}

const translationLangSchema = yup.object({
  lang: yup.mixed<LangDto>().oneOf(Object.values(LangDto)).required(),
  name: yup.string().required(),
});

const productSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  category: idSchema.required(),
  translations: yup.array().of(translationLangSchema).required(),
});

const removedProductSchema = yup.object().shape({
  from: productSchema.required(),
  mainProductCategory: mainProductCategorySchema.required(),
});

const responseSchema = yup.object().shape({
  data: yup.array().of(removedProductSchema).required(),
});
